// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"56d98186","473":"8fbb7f19","501":"953b0c91","741":"fe04b6ac","774":"adf7bf91","782":"0a2393b7","787":"28cb0dcd","883":"00df43c2"}[chunkId] + ".chunk.js";
};